import { render, staticRenderFns } from "./PatientDiagram.vue?vue&type=template&id=a4b875f8&"
import script from "./PatientDiagram.vue?vue&type=script&lang=js&"
export * from "./PatientDiagram.vue?vue&type=script&lang=js&"
import style0 from "./PatientDiagram.vue?vue&type=style&index=0&id=a4b875f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports